import { getSeances, getSeancesList, signSeance } from '../../../../../../../../../store/actions/seance-actions';
import { toast } from 'react-toastify';
import { Dispatch } from 'redux';
import moment from 'moment';
import { DateTimePicker } from 'react-widgets';
import * as React from 'react';
import { ICase } from '../../../../../../../../../types/case';
import { useEffect, useState } from 'react';

const groupModal = ({
    dispatch,
    currentActionData,
    setPopup,
    updateSeance,
    createInvoiceAction,
    caseCurrent,
    id,
    month,
    createStatementAction,
    setCurrentActionData,
    setCurrentAction,
    setEnd,
    setStart,
}: {
    dispatch: Dispatch;
    currentActionData: any;
    setPopup: (param: boolean) => void;
    updateSeance: (status: number, id: string, setPopup: (param: boolean) => void) => void;
    createInvoiceAction: (params: any, setPopup: (param: boolean) => void) => void;
    caseCurrent: ICase | null;
    id: any;
    month: { monthEnd: string; monthStart: string };
    createStatementAction: (params: any, setPopup: (param: boolean) => void) => void;
    setCurrentActionData: any;
    setCurrentAction: any;
    setEnd: any;
    setStart: any;
}) => {
    return {
        SIGN: {
            action: () =>
                dispatch(
                    signSeance(
                        { id: `${currentActionData.id}`, seanceFuture: currentActionData.seanceFuture },
                        () => {
                            toast.success('Session was signed successfully!');
                            setPopup(false);
                        },
                        (errorMessage: string) => {
                            setPopup(false);
                            toast.error(errorMessage);
                        },
                    ),
                ),
            body: (
                <div>
                    Are you sure you want to sign this session? <br /> Please review all information is accurate before
                    signing the note.
                </div>
            ),
        },
        CHANGE_STATUS: {
            action: () => updateSeance(+`${currentActionData?.status}`, `${currentActionData.id}`, setPopup),
            body:
                +currentActionData.status === 5 ? (
                    <div>
                        {' '}
                        <p style={{ marginBottom: 0 }}>Are you sure you want to cancel this session?</p>
                        <p style={{ marginBottom: 0 }}> Session will be permanently removed</p>
                    </div>
                ) : (
                    <div>Are you sure to change status to {currentActionData.label}?</div>
                ),
        },
        INVOICE: {
            action: () => {
                createInvoiceAction(
                    {
                        id: caseCurrent?.id,
                        providerId: id,
                        dateFrom: month.monthStart,
                        dateTo: month.monthEnd,
                    },
                    setPopup,
                );
            },
            body: (
                <div>
                    Are you sure you want to generate an invoice? If you have already generated an invoice, it will be
                    replaced by a new one.
                </div>
            ),
        },
        INVOICE_MANUAL: {
            action: () => {
                return false;
            },
            body: {},
        },
        INVOICE_IS_PAID: {
            action: () => {
                createInvoiceAction(
                    {
                        id: caseCurrent?.id,
                        providerId: id,
                        dateFrom: currentActionData.start,
                        dateTo: currentActionData.end,
                    },
                    setPopup,
                );
            },
            body: (
                <div>
                    Some of the sessions, that you want to include in the new invoice, are already paid. Do you want to
                    continue?
                </div>
            ),
        },
        STATEMENT_DONE: {
            action: () => {
                const start = currentActionData
                    ? moment(currentActionData.seanceDateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss')
                    : '';
                const end = currentActionData
                    ? moment(currentActionData.seanceDateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                    : '';
                createStatementAction(
                    {
                        id: caseCurrent?.id,
                        providerId: id,
                        dateFrom: start,
                        dateTo: end,
                    },
                    setPopup,
                );
            },
            body: (
                <div>
                    <b>Choose statement Date:</b>
                    <div className={'mb-3'}>
                        <span>From:</span>
                        <DateTimePicker
                            onChange={(date: any) => {
                                setCurrentActionData({ ...currentActionData, seanceDateFrom: date });
                            }}
                            value={
                                currentActionData['seanceDateFrom']
                                    ? new Date(`${currentActionData['seanceDateFrom']}`)
                                    : new Date(month.monthStart)
                            }
                            time={false}
                            date={true}
                            format={'MMM D, YYYY'}
                        />
                    </div>

                    <span>To: </span>
                    <DateTimePicker
                        onChange={(date: any) => {
                            setCurrentActionData({ ...currentActionData, seanceDateTo: date });
                        }}
                        value={
                            currentActionData['seanceDateTo']
                                ? new Date(`${currentActionData['seanceDateTo']}`)
                                : new Date(month.monthEnd)
                        }
                        time={false}
                        date={true}
                        format={'MMM D, YYYY'}
                    />
                </div>
            ),
        },
        INVOICE_DONE: {
            action: () => {
                const start = currentActionData
                    ? moment(currentActionData.seanceDateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss')
                    : '';
                const end = currentActionData
                    ? moment(currentActionData.seanceDateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                    : '';

                if (!currentActionData.isCheckedPaid || currentActionData.isCheckedPaid === undefined) {
                    createInvoiceAction(
                        {
                            id: caseCurrent?.id,
                            providerId: id,
                            dateFrom: start,
                            dateTo: end,
                        },
                        setPopup,
                    );
                } else {
                    let isPaid = 0;
                    currentActionData?.seancesList?.list?.forEach((it: any, l: any, arr: any) => {
                        if (it.paymentSeances.length > 0) {
                            isPaid = isPaid + 1;
                            return;
                        }
                    });

                    if (isPaid) {
                        setPopup(false);
                        setCurrentAction('INVOICE_IS_PAID');
                        setPopup(true);
                        setCurrentActionData({
                            start: start,
                            end: end,
                        });
                    } else {
                        createInvoiceAction(
                            {
                                id: caseCurrent?.id,
                                providerId: id,
                                dateFrom: start,
                                dateTo: end,
                            },
                            setPopup,
                        );
                    }
                }
            },
            body: (
                <div>
                    <b>Choose invoice Date:</b>
                    <br />
                    <div className={'mb-3'}>
                        <span>From:</span>
                        <DateTimePicker
                            onChange={(date: any) => {
                                setCurrentActionData({ ...currentActionData, seanceDateFrom: date });

                                const start = date ? moment(date).startOf('day').format('YYYY-MM-DD HH:mm:ss') : '';
                                const end = currentActionData
                                    ? moment(currentActionData.seanceDateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                                    : '';

                                setEnd(end);
                                setStart(start);

                                /* dispatch(
                                    getSeancesList({
                                        page: 1,
                                        filters: {
                                            'occasion.id': caseCurrent?.id,
                                            'provider.id': id,
                                            'seanceDate[after]': start,
                                            'seanceDate[before]': end,
                                            //  'order[seanceDate]': 'asc',
                                        },
                                        itemsPerPage: 1200,
                                    }),
                                );*/
                            }}
                            value={
                                currentActionData['seanceDateFrom']
                                    ? new Date(`${currentActionData['seanceDateFrom']}`)
                                    : new Date(month.monthStart)
                            }
                            time={false}
                            date={true}
                            format={'MMM D, YYYY'}
                        />
                    </div>
                    <span>To: </span>
                    <DateTimePicker
                        onChange={(date: any) => {
                            setCurrentActionData({ ...currentActionData, seanceDateTo: date });

                            const start = currentActionData
                                ? moment(currentActionData.seanceDateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss')
                                : '';
                            const end = date ? moment(date).endOf('day').format('YYYY-MM-DD HH:mm:ss') : '';

                            setEnd(end);
                            setStart(start);
                        }}
                        value={
                            currentActionData['seanceDateTo']
                                ? new Date(`${currentActionData['seanceDateTo']}`)
                                : new Date(month.monthEnd)
                        }
                        time={false}
                        date={true}
                        format={'MMM D, YYYY'}
                    />
                </div>
            ),
        },
    };
};
export default groupModal;
